// React
import React from "react";

// React Router
import { Link } from 'react-router-dom';

// Utils
import { GoogleAnalytics } from '../../Utils';

// Styles
import './navbar.css';

const RightMenu = ({mobile, user, username, onLogout, mobileNavigate}) => {

    // Given a user and whether app is in mobile mode,
    // build and return right side menu
    function buildMenu(mobile, user, username, onLogout, mobileNavigate) {

        // Mobile
        if(mobile) {

            // Signed In
            if(user !== null) {
                return (
                    <React.Fragment>
                    <li className="divider" style={{background:'#343344'}}></li>
                    <li><Link to="/apikeys" href="#"><i className="icon-key"></i>API Keys</Link></li>
                    <li><a href="mailto:accounts@yety.io"><i className="icon-lifebuoy"></i>Help</a></li>
                    <li className="divider" style={{background:'#343344'}}></li>
                    <li><Link to="/login" onClick={onLogout}><i className="icon-switch2"></i>Logout</Link></li>
                    </React.Fragment>
                );
            }
            // Not Signed In
            else {
                return (
                    <li><div className='groovy-signup'><Link to="/login" onClick={mobileNavigate('/login')}><i className="icon-power2 position-left"></i><span>Login / Sign Up</span></Link></div></li>
                );
            }

        }
        else {

            // Signed In
            if(user !== null) {

                return (
                    <li className="dropdown dropdown-user">
                        <a className="dropdown-toggle" data-toggle="dropdown">
                            <i className="icon-power2"></i>
                            <span className="position-right">{username}</span>
                            <span className="caret"></span>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-right">
                            <li><a href="mailto:accounts@yety.io"><i className="icon-lifebuoy"></i>Help</a></li>
                            <li className="divider" style={{background:'#343344'}}></li>
                            <li><Link to="/login" onClick={onLogout}><i className="icon-switch2"></i> Logout</Link></li>
                        </ul>
                    </li>
                );

            }
            // Not Signed In
            else {

                return (
                    <li className="dropdown dropdown-user">
                        
                        <div className='groovy-signup'>
                            <Link to="/login" className="dropdown-toggle" onClick={GoogleAnalytics.newPage('/dashboard')}>
                                <i className="icon-power2"></i>
                                <span className="position-right">{username}</span>
                            </Link>
                        </div>
                        
                    </li>
                );

            }
        }

    }

    // Render the menu
    return buildMenu(mobile, user, username, onLogout, mobileNavigate);
};

export default RightMenu;



// WEBPACK FOOTER //
// ./src/Components/Navbar/RightMenu.js